<template>
  <div class="holder">
    <div v-if="player.gameOver">
      <img src="../assets/boy-sad.gif"/>
    </div>
    <div v-else-if="action.topic === 'sport'">
      <img src="../assets/boy-workout.gif"/>
    </div>
    <div v-else-if="action.topic === 'sleep'">
      <img src="../assets/boy-sleep.gif"/>
    </div>
    <div v-else-if="action.topic === 'math'">
      <img src="../assets/boy-math.gif"/>
    </div>
    <div v-else-if="action.topic === 'french'">
      <img src="../assets/boy-french.gif"/>
    </div>
    <div v-else-if="action.topic === 'gaming'">
      <img src="../assets/boy-gaming.gif"/>
    </div>
    <div v-else>
      <img src="../assets/boy-normal.gif"/>
    </div>
  </div>
</template>

<script>

import { mapState } from "vuex";

export default {
  name: "ActionImage",
  props: {
    action: Object
  },
  computed: {
    ...mapState(["player"])
  },
  data() {
    return {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.holder {
  img {
    max-height: 40vh;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
